import { render } from "./Manavisfesta202505.vue?vue&type=template&id=af805800&scoped=true"
import script from "./Manavisfesta202505.vue?vue&type=script&lang=js"
export * from "./Manavisfesta202505.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-af805800"

export default script